import { render, staticRenderFns } from "./IntegralOrderSubmission.vue?vue&type=template&id=06120d32&scoped=true"
import script from "./IntegralOrderSubmission.vue?vue&type=script&lang=js"
export * from "./IntegralOrderSubmission.vue?vue&type=script&lang=js"
import style0 from "./IntegralOrderSubmission.vue?vue&type=style&index=0&id=06120d32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06120d32",
  null
  
)

export default component.exports